// Mobile Product Slider - Lightweight Native Solution
// Replaces Slick.js on mobile for faster LCP

(function() {
  'use strict';
  
  // Check if mobile viewport
  function isMobile() {
    return window.innerWidth <= 767;
  }
  
  // Initialize mobile slider
  function initMobileSlider() {
    if (!isMobile()) return;
    
    const mobileSliders = document.querySelectorAll('[data-mobile-slider]');
    
    mobileSliders.forEach(function(slider) {
      const container = slider.querySelector('.mobile-slider-container');
      const dotsContainer = slider.querySelector('.mobile-slider-dots');
      const dots = slider.querySelectorAll('.mobile-dot');
      const prevBtn = slider.querySelector('.mobile-slider-nav.prev');
      const nextBtn = slider.querySelector('.mobile-slider-nav.next');
      const slides = slider.querySelectorAll('.mobile-slide');
      
      if (!container || !dots.length) return;
      
      // Show mobile slider, hide desktop slider
      slider.style.display = 'block';
      
      // Update active dot on scroll
      let scrollTimeout;
      container.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          const scrollLeft = container.scrollLeft;
          const slideWidth = container.offsetWidth;
          const activeIndex = Math.round(scrollLeft / slideWidth);
          
          dots.forEach((dot, index) => {
            if (index === activeIndex) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });
        }, 50);
      });
      
      // Dot navigation
      dots.forEach((dot, index) => {
        dot.addEventListener('click', function() {
          const slideWidth = container.offsetWidth;
          container.scrollTo({
            left: slideWidth * index,
            behavior: 'smooth'
          });
        });
      });
      
      // Previous button
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          const scrollLeft = container.scrollLeft;
          const slideWidth = container.offsetWidth;
          const newIndex = Math.max(0, Math.round(scrollLeft / slideWidth) - 1);
          
          container.scrollTo({
            left: slideWidth * newIndex,
            behavior: 'smooth'
          });
        });
      }
      
      // Next button
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          const scrollLeft = container.scrollLeft;
          const slideWidth = container.offsetWidth;
          const newIndex = Math.min(slides.length - 1, Math.round(scrollLeft / slideWidth) + 1);
          
          container.scrollTo({
            left: slideWidth * newIndex,
            behavior: 'smooth'
          });
        });
      }
      
      // Touch support for swipe gestures
      let startX = 0;
      let scrollLeft = 0;
      let isDown = false;
      
      container.addEventListener('touchstart', function(e) {
        startX = e.touches[0].pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
        isDown = true;
      });
      
      container.addEventListener('touchmove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.touches[0].pageX - container.offsetLeft;
        const walk = (x - startX) * 2;
        container.scrollLeft = scrollLeft - walk;
      });
      
      container.addEventListener('touchend', function() {
        isDown = false;
      });
    });
  }
  
  // Handle resize events
  function handleResize() {
    const mobileSliders = document.querySelectorAll('[data-mobile-slider]');
    
    if (isMobile()) {
      // Initialize mobile sliders
      initMobileSlider();
    } else {
      // Show desktop sliders, hide mobile sliders
      mobileSliders.forEach(function(slider) {
        slider.style.display = 'none';
      });
    }
  }
  
  // Initialize on DOM content loaded
  function init() {
    handleResize();
    
    // Re-check on resize with debouncing
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResize, 150);
    });
  }
  
  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
